import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "./Components/baseUrl";
import { toast } from "react-toastify";
import Menu from "./Components/Menu";
import packageJson from "../package.json";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import CommentModal from "./Components/CommentModal";
import { CopyToClipboard } from "react-copy-to-clipboard";
import InfiniteScroll from "react-infinite-scroll-component";

const Home = () => {
    useEffect(() => {
        document.title = "پایا";
        token == null && navigate("/login", { replace: true });
        let version = localStorage.getItem("version");
        if (version != packageJson.version) {
            if ("caches" in window) {
                caches.keys().then((names) => {
                    // Delete all the cache files
                    names.forEach((name) => {
                        caches.delete(name);
                    });
                });

                // Makes sure the page reloads. Changes are only visible after you refresh.
                window.location.reload(true);
            }

            localStorage.clear();
            localStorage.setItem("version", packageJson.version);
        }
    }, []);
    const [hasMore, setHasMore] = useState(true);

    const navigate = useNavigate();
    let token;
    if (typeof window !== "undefined") {
        token = localStorage.getItem("token");
    }
    useEffect(() => {
        const handleScroll = () => {
            const header = document.getElementById("search_box");
            const scrollTop =
                window.pageYOffset || document.documentElement.scrollTop;
            header.style.opacity = 0 + scrollTop / 200;
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            // Cleanup: Remove the event listener when the component unmounts
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    const [activeMenu, setActiveMenu] = useState(0);
    const openMenuHandler = (i) => {
        setActiveMenu(i);
        console.log(i);
    };
    const [filter, setFilter] = useState("");
    const [showCommentModal, setShowCommentModal] = useState(false);
    const [selectedShopComments, setSelectedShopComments] = useState([]);
    const [commentShop, setCommentShop] = useState("");
    const [compList, setCompList] = useState([]);
    const [showFilter, setShowFilter] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [loading, setLoading] = useState(true);
    const [pages, setPages] = useState([]);
    const [numPages, setNumPages] = useState([]);
    const getShopsHandler = (filt) => {
        setShowFilter(false);
        setPages([]);
        let config;
        if (searchText && searchText.length !== 0) {
            config = {
                url: `${baseUrl}/company?count=10&search=${searchText}${
                    filt ? "&filter=" + filt : ""
                }`,
                method: "GET",
            };
        } else {
            config = {
                url: `${baseUrl}/company?count=10${
                    filt ? "&filter=" + filt : ""
                }`,
                method: "GET",
            };
        }
        axios(config)
            .then((res) => {
                setLoading(false);
                res &&
                    res.data &&
                    res.data.data &&
                    res?.data?.data?.companies &&
                    setCompList(res?.data?.data?.companies);
                res &&
                    res.data &&
                    res.data.data &&
                    res?.data?.data?.paginate &&
                    setPages(res?.data?.data?.paginate);
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    useEffect(() => {
        getShopsHandler();
    }, []);
    useEffect(() => {
        let total = pages.totalItems;
        const totalPagesCount = Math.ceil(total / 10);
        setNumPages(
            Array.from({ length: totalPagesCount }, (_, index) => index + 1)
        );
    }, [pages]);
    const pageHandler = (filt) => {
        let config;
        if (searchText && searchText.length !== 0) {
            config = {
                url: `${baseUrl}/company?count=10&search=${searchText}${
                    filt ? "&filter=" + filt : ""
                }&page=${pages.nextPage}`,
                method: "GET",
            };
        } else {
            config = {
                url: `${baseUrl}/company?count=10${
                    filt ? "&filter=" + filt : ""
                }&page=${pages.nextPage}`,
                method: "GET",
            };
        }
        numPages.length >= pages.nextPage &&
            axios(config)
                .then((res) => {
                    res &&
                        res.data &&
                        res.data.data &&
                        res.data.data.companies &&
                        setCompList((prevData) => [
                            ...prevData,
                            ...res.data.data.companies.map((item) => ({
                                ...item,
                                num: 0,
                            })),
                        ]);
                    res &&
                        res.data &&
                        res.data.data &&
                        res.data.data.paginate &&
                        setPages(res.data.data.paginate);
                })
                .catch((err) => {
                    toast.error(err.response.data.message, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                });
        numPages.length < pages.nextPage && setHasMore(false);
    };
    const [addCompList, setAddCompList] = useState([]);
    useEffect(() => {
        let config;
        config = {
            url: `${baseUrl}/advertises`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res &&
                    res.data &&
                    res.data.data &&
                    res?.data?.data?.advertises &&
                    setAddCompList(res?.data?.data?.advertises);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    }, []);
    const copyHandler = (item) => {
        setActiveMenu(0);
        toast.success("آدرس محصولات کپی شد", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };
    const showNotifHandler = () => {
        toast.success(
            "با خرید از این شرکت از مجموعه پایا تخفیف جداگانه ای بگیرید",
            {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            }
        );
    };
    return (
        <div className="container">
            {(activeMenu !== 0 || showCommentModal || showFilter) && (
                <div
                    onClick={() => {
                        setActiveMenu(0);
                        setShowCommentModal(false);
                        setShowFilter(false);
                    }}
                    id="bg_gray"
                    className="bg-gray"
                ></div>
            )}
            {showFilter && (
                <div id="filter_modal" className="filter-modal">
                    <div className="filter-modal-head">
                        <svg
                            className="orang-filter"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M2 12C2 6.48 6.44 2 12 2C18.67 2 22 7.56 22 7.56M22 7.56V2.56M22 7.56H17.56"
                                stroke="#FF0000"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                opacity="0.4"
                                d="M21.89 12C21.89 17.52 17.41 22 11.89 22C6.37 22 3 16.44 3 16.44M3 16.44H7.52M3 16.44V21.44"
                                stroke="#FF0000"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                    <h2>
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M21 7L11 7"
                                stroke="#3BA7E4"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M7 7C7 8.10457 6.10457 9 5 9C3.89543 9 3 8.10457 3 7C3 5.89543 3.89543 5 5 5"
                                stroke="#3BA7E4"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                            <path
                                d="M3 17L13 17"
                                stroke="#3BA7E4"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M17 17C17 18.1046 17.8954 19 19 19C20.1046 19 21 18.1046 21 17C21 15.8954 20.1046 15 19 15"
                                stroke="#3BA7E4"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                        </svg>
                        فیلتر
                    </h2>
                    <button
                        onClick={() => {
                            setFilter("most_popular");
                            getShopsHandler("most_popular");
                        }}
                        className="mt-3"
                    >
                        محبوب ترینها
                    </button>
                    <button
                        onClick={() => {
                            setFilter("most_visited");
                            getShopsHandler("most_visited");
                        }}
                        className="mt-3"
                    >
                        پربازدیدترین
                    </button>
                    <button
                        onClick={() => {
                            setFilter("most_expensive");
                            getShopsHandler("most_expensive");
                        }}
                        className="mt-3"
                    >
                        گرانترین ها
                    </button>
                    <button
                        onClick={() => {
                            setFilter("cheapest");
                            getShopsHandler("cheapest");
                        }}
                        className="mt-3"
                    >
                        ارزانترین ها
                    </button>
                    <button
                        onClick={() => {
                            setFilter("newest");
                            getShopsHandler("newest");
                        }}
                        className="mt-3"
                    >
                        جدیدترین ها
                    </button>
                </div>
            )}
            <div className="index-main">
                <h1></h1>
                <div className="search-box" id="search_box">
                    <div className="pos-rel-search">
                        <input type="text" placeholder="جستجو کنید" />
                        <svg
                            className="search-svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M18.5831 13.5489C19.204 11.7018 19.1293 9.69155 18.3731 7.89557C17.6169 6.09959 16.2312 4.64137 14.4761 3.79465C12.7209 2.94793 10.7171 2.77094 8.84074 3.29691C6.96438 3.82287 5.3445 5.01562 4.28521 6.65125C3.22592 8.28688 2.80005 10.2529 3.08754 12.1803C3.37504 14.1076 4.35614 15.8638 5.84666 17.1191C7.33718 18.3744 9.23463 19.0424 11.1828 18.9979C13.131 18.9534 14.9959 18.1993 16.4275 16.8772"
                                stroke="#A2A2A2"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M16.5 16.958L21.5 21.958"
                                stroke="#A2A2A2"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>

                    <div
                        onClick={() => setShowFilter(true)}
                        className="svg-rec"
                        onclick="showFilterModal()"
                    >
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M21 7L11 7"
                                stroke="#A2A2A2"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M7 7C7 8.10457 6.10457 9 5 9C3.89543 9 3 8.10457 3 7C3 5.89543 3.89543 5 5 5"
                                stroke="#A2A2A2"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                            <path
                                d="M3 17L13 17"
                                stroke="#A2A2A2"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M17 17C17 18.1046 17.8954 19 19 19C20.1046 19 21 18.1046 21 17C21 15.8954 20.1046 15 19 15"
                                stroke="#A2A2A2"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                        </svg>
                    </div>
                </div>
                {showCommentModal && (
                    <CommentModal
                        id={commentShop}
                        item={selectedShopComments}
                        setShow={setShowCommentModal}
                    />
                )}
                {addCompList &&
                    addCompList.length !== 0 &&
                    addCompList.map((item) => {
                        return (
                            <div
                                className="shop-box adds-shop"
                                id="card_5"
                                onClick={() => {
                                    navigate("/products/" + item.company_id);
                                }}
                            >
                                <div className="head">
                                    <h2>{item.company.company_name}</h2>
                                    <div
                                        className="orange-circle"
                                        onClick={(e) => {
                                            openMenuHandler(item.id);
                                            e.stopPropagation();
                                        }}
                                    >
                                        <svg
                                            width="19"
                                            height="19"
                                            viewBox="0 0 19 19"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <rect
                                                x="1"
                                                y="1"
                                                width="7"
                                                height="7"
                                                rx="2.5"
                                                stroke="white"
                                                strokeWidth="1.5"
                                            />
                                            <rect
                                                x="1"
                                                y="11"
                                                width="7"
                                                height="7"
                                                rx="2.5"
                                                stroke="white"
                                                strokeWidth="1.5"
                                            />
                                            <rect
                                                x="11"
                                                y="1"
                                                width="7"
                                                height="7"
                                                rx="2.5"
                                                stroke="white"
                                                strokeWidth="1.5"
                                            />
                                            <rect
                                                x="11"
                                                y="11"
                                                width="7"
                                                height="7"
                                                rx="2.5"
                                                stroke="white"
                                                strokeWidth="1.5"
                                            />
                                        </svg>
                                    </div>
                                    <div
                                        className={
                                            activeMenu == item.id
                                                ? "open-menu "
                                                : "open-menu close"
                                        }
                                        id={"menu-" + item.id}
                                    >
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                navigate(
                                                    "/brands/" + item.company_id
                                                );
                                            }}
                                        >
                                            <path
                                                d="M5.16024 17.79C5.42024 18.37 5.73023 18.95 6.09023 19.51C6.85023 20.68 7.87023 21.99 9.20023 22C9.75023 22.01 10.1202 21.84 10.5202 21.66C10.9802 21.46 11.4702 21.23 12.3302 21.23C13.1902 21.22 13.6802 21.45 14.1302 21.66C14.5202 21.84 14.8802 22 15.4202 22C16.7502 21.99 17.8302 20.53 18.5902 19.37C19.1402 18.53 19.3402 18.11 19.7602 17.17C16.6802 16 16.1802 11.61 19.2302 9.92999C18.3002 8.75999 16.9902 8.09 15.7602 8.09C14.8702 8.09 14.2602 8.32 13.7102 8.53C13.2502 8.71 12.8202 8.87 12.3102 8.87C11.7502 8.87 11.2602 8.69001 10.7402 8.51001C10.1702 8.31001 9.58023 8.09 8.84023 8.09C7.45023 8.09 5.98024 8.94 5.04024 10.38C4.59024 11.08 4.32023 12 4.24023 13.03M15.4102 2C15.5702 3.1 15.1202 4.19001 14.5302 4.95001C13.9002 5.77001 12.8002 6.41 11.7402 6.37C11.5502 5.31 12.0402 4.21999 12.6402 3.48999C13.3102 2.68999 14.4402 2.07 15.4102 2Z"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                strokeMiterlimit="10"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                        <CopyToClipboard
                                            text={
                                                "https://my.payacom.com/products/" +
                                                item.id
                                            }
                                        >
                                            <svg
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    copyHandler(item);
                                                }}
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    opacity="0.34"
                                                    d="M16.96 6.16992C18.96 7.55992 20.34 9.76992 20.62 12.3199"
                                                    stroke="white"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    opacity="0.34"
                                                    d="M3.49023 12.3702C3.75023 9.83021 5.11023 7.62021 7.09023 6.22021"
                                                    stroke="white"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    opacity="0.34"
                                                    d="M8.18994 20.9399C9.34994 21.5299 10.6699 21.8599 12.0599 21.8599C13.3999 21.8599 14.6599 21.5599 15.7899 21.0099"
                                                    stroke="white"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M12.0598 7.70014C13.5951 7.70014 14.8398 6.45549 14.8398 4.92014C14.8398 3.38479 13.5951 2.14014 12.0598 2.14014C10.5244 2.14014 9.27979 3.38479 9.27979 4.92014C9.27979 6.45549 10.5244 7.70014 12.0598 7.70014Z"
                                                    stroke="white"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M4.8298 19.9199C6.36516 19.9199 7.60981 18.6752 7.60981 17.1399C7.60981 15.6045 6.36516 14.3599 4.8298 14.3599C3.29445 14.3599 2.0498 15.6045 2.0498 17.1399C2.0498 18.6752 3.29445 19.9199 4.8298 19.9199Z"
                                                    stroke="white"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M19.1701 19.9199C20.7055 19.9199 21.9501 18.6752 21.9501 17.1399C21.9501 15.6045 20.7055 14.3599 19.1701 14.3599C17.6348 14.3599 16.3901 15.6045 16.3901 17.1399C16.3901 18.6752 17.6348 19.9199 19.1701 19.9199Z"
                                                    stroke="white"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </CopyToClipboard>
                                        <svg
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setShowCommentModal(true);
                                                setActiveMenu(0);
                                                setCommentShop(item.company_id);
                                            }}
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H16C20 2 22 4 22 8V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19Z"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                strokeMiterlimit="10"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                opacity="0.4"
                                                d="M7 8H17"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                opacity="0.4"
                                                d="M7 13H13"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                        <div
                                            onClick={(e) => {
                                                e.stopPropagation();
                                            }}
                                            className="orange-circle"
                                        >
                                            <svg
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M21 13V17C21 19.7614 18.7614 22 16 22H8C5.23858 22 3 19.7614 3 17V9C3 6.23858 5.23858 4 8 4H12"
                                                    stroke="#F2F2F2"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                />
                                                <path
                                                    d="M13.2958 6.87469L16.7465 3.4187C17.527 2.63706 18.7928 2.63658 19.5739 3.41763L21.2334 5.07712C22.0078 5.85151 22.0158 7.10516 21.2514 7.88943L13.8224 15.5116C13.258 16.0907 12.4839 16.4172 11.6755 16.4172L9.40332 16.4171C8.76638 16.4171 8.25772 15.8861 8.28451 15.2493V15.2493L8.33363 14.0815L8.38275 12.9137V12.9137C8.41434 12.1627 8.72648 11.4509 9.25741 10.9192L10.8638 9.31032"
                                                    stroke="#F2F2F2"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                />
                                                <path
                                                    d="M17.6777 7.60687L19.3638 9.29297"
                                                    stroke="#F2F2F2"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <Swiper
                                    modules={[
                                        Navigation,
                                        Pagination,
                                        Scrollbar,
                                        A11y,
                                    ]}
                                    spaceBetween={20}
                                    slidesPerView={4}
                                    loop={false}
                                    onSwiper={(swiper) => console.log(swiper)}
                                    onSlideChange={() =>
                                        console.log("slide change")
                                    }
                                    breakpoints={{
                                        // when window width is >= 640px
                                        0: {
                                            slidesPerView: 4,
                                        },
                                        450: {
                                            slidesPerView: 4,
                                        },
                                        // when window width is >= 768px
                                        728: {
                                            slidesPerView: 5,
                                        },
                                        930: {
                                            slidesPerView: 5,
                                        },
                                        1208: {
                                            slidesPerView: 5,
                                        },
                                    }}
                                >
                                    {item.products &&
                                        item.products.length !== 0 &&
                                        item.products.map((i, index) => (
                                            <SwiperSlide className="swiper-img">
                                                <img src={i.image} alt="" />
                                            </SwiperSlide>
                                        ))}
                                </Swiper>
                                <div className="star">
                                    {item.rates}
                                    <svg
                                        width="24"
                                        height="11"
                                        viewBox="0 0 24 11"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            opacity="0.1"
                                            d="M6 0L7.34708 4.1459H11.7063L8.17963 6.7082L9.52671 10.8541L6 8.2918L2.47329 10.8541L3.82037 6.7082L0.293661 4.1459H4.65292L6 0Z"
                                            fill="#F15A22"
                                        />
                                        <path
                                            opacity="0.3"
                                            d="M9 0L10.3471 4.1459H14.7063L11.1796 6.7082L12.5267 10.8541L9 8.2918L5.47329 10.8541L6.82037 6.7082L3.29366 4.1459H7.65292L9 0Z"
                                            fill="#F15A22"
                                        />
                                        <path
                                            d="M12 0L13.3471 4.1459H17.7063L14.1796 6.7082L15.5267 10.8541L12 8.2918L8.47329 10.8541L9.82037 6.7082L6.29366 4.1459H10.6529L12 0Z"
                                            fill="#F15A22"
                                            fill-opacity="0.5"
                                        />
                                        <path
                                            d="M15 0L16.3471 4.1459H20.7063L17.1796 6.7082L18.5267 10.8541L15 8.2918L11.4733 10.8541L12.8204 6.7082L9.29366 4.1459H13.6529L15 0Z"
                                            fill="#F15A22"
                                            fill-opacity="0.8"
                                        />
                                        <path
                                            d="M18 0L19.3471 4.1459H23.7063L20.1796 6.7082L21.5267 10.8541L18 8.2918L14.4733 10.8541L15.8204 6.7082L12.2937 4.1459H16.6529L18 0Z"
                                            fill="#F15A22"
                                        />
                                    </svg>
                                </div>
                                <div className="rate">{item?.discount}%</div>
                                {item?.paya_type == "commission" && (
                                    <div
                                        onClick={(e) => {
                                            showNotifHandler();
                                            e.stopPropagation();
                                        }}
                                        className="gift-icon-div"
                                    >
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M3.96997 18C3.96997 21 4.96997 22 7.96997 22H15.97C18.97 22 19.97 21 19.97 18V10H3.96997V13.84"
                                                stroke="#FF0000"
                                                strokeWidth="1.5"
                                                strokeMiterlimit="10"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M21.5 7V8C21.5 9.1 20.97 10 19.5 10H4.5C2.97 10 2.5 9.1 2.5 8V7C2.5 5.9 2.97 5 4.5 5H19.5C20.97 5 21.5 5.9 21.5 7Z"
                                                stroke="#FF0000"
                                                strokeWidth="1.5"
                                                strokeMiterlimit="10"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M11.64 4.99994H6.12003C5.78003 4.62994 5.79003 4.05994 6.15003 3.69994L7.57003 2.27994C7.94003 1.90994 8.55003 1.90994 8.92003 2.27994L11.64 4.99994Z"
                                                stroke="#FF0000"
                                                strokeWidth="1.5"
                                                strokeMiterlimit="10"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M17.8701 4.99994H12.3501L15.0701 2.27994C15.4401 1.90994 16.0501 1.90994 16.4201 2.27994L17.8401 3.69994C18.2001 4.05994 18.2101 4.62994 17.8701 4.99994Z"
                                                stroke="#FF0000"
                                                strokeWidth="1.5"
                                                strokeMiterlimit="10"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M8.93994 10V15.14C8.93994 15.94 9.81994 16.41 10.4899 15.98L11.4299 15.36C11.7699 15.14 12.1999 15.14 12.5299 15.36L13.4199 15.96C14.0799 16.4 14.9699 15.93 14.9699 15.13V10H8.93994Z"
                                                stroke="#FF0000"
                                                strokeWidth="1.5"
                                                strokeMiterlimit="10"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                <div className="w-100 d-flex justify-content-center home-main">
                    <InfiniteScroll
                        dataLength={compList.length}
                        next={pageHandler}
                        hasMore={hasMore}
                        loader={
                            compList.length !== 0 && (
                                <div className="mx-auto d-flex justify-content-center mt-4">
                                    <img
                                        src="/assets/images/loading.gif"
                                        width={40}
                                    />
                                </div>
                            )
                        }
                    >
                        {loading ? (
                            <div className="mx-auto d-flex justify-content-center mt-4">
                                <img
                                    src="/assets/images/loading.gif"
                                    width={40}
                                    className="mt-4"
                                />
                            </div>
                        ) : compList && compList.length !== 0 ? (
                            compList.map((item) => {
                                return (
                                    <div
                                        className="shop-box"
                                        id="card_5"
                                        onClick={() => {
                                            navigate("/products/" + item.id);
                                        }}
                                    >
                                        <div className="head">
                                            <h2>{item.name}</h2>
                                            <div
                                                className="orange-circle"
                                                onClick={(e) => {
                                                    openMenuHandler(item.id);
                                                    e.stopPropagation();
                                                }}
                                            >
                                                <svg
                                                    width="19"
                                                    height="19"
                                                    viewBox="0 0 19 19"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <rect
                                                        x="1"
                                                        y="1"
                                                        width="7"
                                                        height="7"
                                                        rx="2.5"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                    />
                                                    <rect
                                                        x="1"
                                                        y="11"
                                                        width="7"
                                                        height="7"
                                                        rx="2.5"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                    />
                                                    <rect
                                                        x="11"
                                                        y="1"
                                                        width="7"
                                                        height="7"
                                                        rx="2.5"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                    />
                                                    <rect
                                                        x="11"
                                                        y="11"
                                                        width="7"
                                                        height="7"
                                                        rx="2.5"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                    />
                                                </svg>
                                            </div>
                                            <div
                                                className={
                                                    activeMenu == item.id
                                                        ? "open-menu "
                                                        : "open-menu close"
                                                }
                                                id={"menu-" + item.id}
                                            >
                                                <svg
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        navigate(
                                                            "/brands/" + item.id
                                                        );
                                                    }}
                                                >
                                                    <path
                                                        d="M5.16024 17.79C5.42024 18.37 5.73023 18.95 6.09023 19.51C6.85023 20.68 7.87023 21.99 9.20023 22C9.75023 22.01 10.1202 21.84 10.5202 21.66C10.9802 21.46 11.4702 21.23 12.3302 21.23C13.1902 21.22 13.6802 21.45 14.1302 21.66C14.5202 21.84 14.8802 22 15.4202 22C16.7502 21.99 17.8302 20.53 18.5902 19.37C19.1402 18.53 19.3402 18.11 19.7602 17.17C16.6802 16 16.1802 11.61 19.2302 9.92999C18.3002 8.75999 16.9902 8.09 15.7602 8.09C14.8702 8.09 14.2602 8.32 13.7102 8.53C13.2502 8.71 12.8202 8.87 12.3102 8.87C11.7502 8.87 11.2602 8.69001 10.7402 8.51001C10.1702 8.31001 9.58023 8.09 8.84023 8.09C7.45023 8.09 5.98024 8.94 5.04024 10.38C4.59024 11.08 4.32023 12 4.24023 13.03M15.4102 2C15.5702 3.1 15.1202 4.19001 14.5302 4.95001C13.9002 5.77001 12.8002 6.41 11.7402 6.37C11.5502 5.31 12.0402 4.21999 12.6402 3.48999C13.3102 2.68999 14.4402 2.07 15.4102 2Z"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeMiterlimit="10"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                                <CopyToClipboard
                                                    text={
                                                        "https://my.payacom.com/products/" +
                                                        item.id
                                                    }
                                                >
                                                    <svg
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            copyHandler(item);
                                                        }}
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            opacity="0.34"
                                                            d="M16.96 6.16992C18.96 7.55992 20.34 9.76992 20.62 12.3199"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            opacity="0.34"
                                                            d="M3.49023 12.3702C3.75023 9.83021 5.11023 7.62021 7.09023 6.22021"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            opacity="0.34"
                                                            d="M8.18994 20.9399C9.34994 21.5299 10.6699 21.8599 12.0599 21.8599C13.3999 21.8599 14.6599 21.5599 15.7899 21.0099"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M12.0598 7.70014C13.5951 7.70014 14.8398 6.45549 14.8398 4.92014C14.8398 3.38479 13.5951 2.14014 12.0598 2.14014C10.5244 2.14014 9.27979 3.38479 9.27979 4.92014C9.27979 6.45549 10.5244 7.70014 12.0598 7.70014Z"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M4.8298 19.9199C6.36516 19.9199 7.60981 18.6752 7.60981 17.1399C7.60981 15.6045 6.36516 14.3599 4.8298 14.3599C3.29445 14.3599 2.0498 15.6045 2.0498 17.1399C2.0498 18.6752 3.29445 19.9199 4.8298 19.9199Z"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M19.1701 19.9199C20.7055 19.9199 21.9501 18.6752 21.9501 17.1399C21.9501 15.6045 20.7055 14.3599 19.1701 14.3599C17.6348 14.3599 16.3901 15.6045 16.3901 17.1399C16.3901 18.6752 17.6348 19.9199 19.1701 19.9199Z"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </CopyToClipboard>
                                                <svg
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setShowCommentModal(
                                                            true
                                                        );
                                                        setActiveMenu(0);
                                                        setCommentShop(item.id);
                                                        setSelectedShopComments(
                                                            item.comments
                                                        );
                                                    }}
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H16C20 2 22 4 22 8V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19Z"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeMiterlimit="10"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        opacity="0.4"
                                                        d="M7 8H17"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        opacity="0.4"
                                                        d="M7 13H13"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                                <div className="orange-circle">
                                                    <svg
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M21 13V17C21 19.7614 18.7614 22 16 22H8C5.23858 22 3 19.7614 3 17V9C3 6.23858 5.23858 4 8 4H12"
                                                            stroke="#F2F2F2"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                        />
                                                        <path
                                                            d="M13.2958 6.87469L16.7465 3.4187C17.527 2.63706 18.7928 2.63658 19.5739 3.41763L21.2334 5.07712C22.0078 5.85151 22.0158 7.10516 21.2514 7.88943L13.8224 15.5116C13.258 16.0907 12.4839 16.4172 11.6755 16.4172L9.40332 16.4171C8.76638 16.4171 8.25772 15.8861 8.28451 15.2493V15.2493L8.33363 14.0815L8.38275 12.9137V12.9137C8.41434 12.1627 8.72648 11.4509 9.25741 10.9192L10.8638 9.31032"
                                                            stroke="#F2F2F2"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                        />
                                                        <path
                                                            d="M17.6777 7.60687L19.3638 9.29297"
                                                            stroke="#F2F2F2"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <Swiper
                                            // install Swiper modules
                                            modules={[
                                                Navigation,
                                                Pagination,
                                                Scrollbar,
                                                A11y,
                                            ]}
                                            spaceBetween={20}
                                            slidesPerView={4}
                                            loop={false}
                                            onSwiper={(swiper) =>
                                                console.log(swiper)
                                            }
                                            onSlideChange={() =>
                                                console.log("slide change")
                                            }
                                            breakpoints={{
                                                // when window width is >= 640px
                                                0: {
                                                    slidesPerView: 4,
                                                },
                                                450: {
                                                    slidesPerView: 4,
                                                },
                                                // when window width is >= 768px
                                                728: {
                                                    slidesPerView: 5,
                                                },
                                                930: {
                                                    slidesPerView: 5,
                                                },
                                                1208: {
                                                    slidesPerView: 5,
                                                },
                                            }}
                                        >
                                            {item.products &&
                                                item.products.length !== 0 &&
                                                item.products.map(
                                                    (i, index) => (
                                                        <SwiperSlide className="swiper-img">
                                                            <img
                                                                src={i.image}
                                                                alt=""
                                                            />
                                                        </SwiperSlide>
                                                    )
                                                )}
                                        </Swiper>
                                        <div className="star">
                                            {item.rates}
                                            <svg
                                                width="24"
                                                height="11"
                                                viewBox="0 0 24 11"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    opacity="0.1"
                                                    d="M6 0L7.34708 4.1459H11.7063L8.17963 6.7082L9.52671 10.8541L6 8.2918L2.47329 10.8541L3.82037 6.7082L0.293661 4.1459H4.65292L6 0Z"
                                                    fill="#F15A22"
                                                />
                                                <path
                                                    opacity="0.3"
                                                    d="M9 0L10.3471 4.1459H14.7063L11.1796 6.7082L12.5267 10.8541L9 8.2918L5.47329 10.8541L6.82037 6.7082L3.29366 4.1459H7.65292L9 0Z"
                                                    fill="#F15A22"
                                                />
                                                <path
                                                    d="M12 0L13.3471 4.1459H17.7063L14.1796 6.7082L15.5267 10.8541L12 8.2918L8.47329 10.8541L9.82037 6.7082L6.29366 4.1459H10.6529L12 0Z"
                                                    fill="#F15A22"
                                                    fill-opacity="0.5"
                                                />
                                                <path
                                                    d="M15 0L16.3471 4.1459H20.7063L17.1796 6.7082L18.5267 10.8541L15 8.2918L11.4733 10.8541L12.8204 6.7082L9.29366 4.1459H13.6529L15 0Z"
                                                    fill="#F15A22"
                                                    fill-opacity="0.8"
                                                />
                                                <path
                                                    d="M18 0L19.3471 4.1459H23.7063L20.1796 6.7082L21.5267 10.8541L18 8.2918L14.4733 10.8541L15.8204 6.7082L12.2937 4.1459H16.6529L18 0Z"
                                                    fill="#F15A22"
                                                />
                                            </svg>
                                        </div>
                                        {item?.max_discount ? (
                                            <div className="rate">
                                                {item?.max_discount}%
                                            </div>
                                        ) : (
                                            ""
                                        )}

                                        {item?.paya_type == "commission" && (
                                            <div
                                                onClick={(e) => {
                                                    showNotifHandler();
                                                    e.stopPropagation();
                                                }}
                                                className="gift-icon-div"
                                            >
                                                <svg
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M3.96997 18C3.96997 21 4.96997 22 7.96997 22H15.97C18.97 22 19.97 21 19.97 18V10H3.96997V13.84"
                                                        stroke="#FF0000"
                                                        strokeWidth="1.5"
                                                        strokeMiterlimit="10"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M21.5 7V8C21.5 9.1 20.97 10 19.5 10H4.5C2.97 10 2.5 9.1 2.5 8V7C2.5 5.9 2.97 5 4.5 5H19.5C20.97 5 21.5 5.9 21.5 7Z"
                                                        stroke="#FF0000"
                                                        strokeWidth="1.5"
                                                        strokeMiterlimit="10"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M11.64 4.99994H6.12003C5.78003 4.62994 5.79003 4.05994 6.15003 3.69994L7.57003 2.27994C7.94003 1.90994 8.55003 1.90994 8.92003 2.27994L11.64 4.99994Z"
                                                        stroke="#FF0000"
                                                        strokeWidth="1.5"
                                                        strokeMiterlimit="10"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M17.8701 4.99994H12.3501L15.0701 2.27994C15.4401 1.90994 16.0501 1.90994 16.4201 2.27994L17.8401 3.69994C18.2001 4.05994 18.2101 4.62994 17.8701 4.99994Z"
                                                        stroke="#FF0000"
                                                        strokeWidth="1.5"
                                                        strokeMiterlimit="10"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M8.93994 10V15.14C8.93994 15.94 9.81994 16.41 10.4899 15.98L11.4299 15.36C11.7699 15.14 12.1999 15.14 12.5299 15.36L13.4199 15.96C14.0799 16.4 14.9699 15.93 14.9699 15.13V10H8.93994Z"
                                                        stroke="#FF0000"
                                                        strokeWidth="1.5"
                                                        strokeMiterlimit="10"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </div>
                                        )}
                                    </div>
                                );
                            })
                        ) : (
                            <div className="mx-auto d-flex justify-content-center align-items-center mt-4">
                                <span className="mt-3 refresh-text">
                                    برای نمایش لیست شرکتها صفحه را رفرش کنید
                                </span>
                            </div>
                        )}
                    </InfiniteScroll>
                </div>

                <Menu active="home" />
            </div>
        </div>
    );
};

export default Home;
